export enum SitesRequestStatusAction {
  Load = '[Sites] [Request Status] Load',
  Success = '[Sites] [Request Status] Success',
  Error = '[Sites] [Request Status] Error',
}
